import React from "react";
import { createTheme } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { ThemeProvider } from "@material-ui/styles";
import ScreenContextProvider from "./contexts/ScreenContext";
import AuthContextProvider from "./contexts/AuthContext";
import AdminContextProvider from "./contexts/AdminContext";
import HoursContextProvider from "./contexts/HoursContext";
import ClientContextProvider from "./contexts/ClientContext";
import InventoryContextProvider from "./contexts/InventoryContext";
import MaintenanceContextProvider from "./contexts/MaintenanceContext";
import { DataPulseProvider } from "./contexts/DataPulseContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import ErrorBoundary from "./components/ErrorBoundary";
import Routes from "./Routes";

const theme = createTheme({
  typography: {
    fontSize: 12,
  },
  palette: {
    primary: { main: "#b71c1c" },
    secondary: { main: "#1976d2" },
  },
  overrides: {
    MuiDialog: {
      root: {
        // Potential future accessibility overrides
      },
    },
    MuiToggleButton: {
      root: {
        "&$selected": {
          color: "white",
          backgroundColor: "#b71c1c",
          "&:hover": {
            color: "white",
            backgroundColor: "#b71c1c",
          },
        },
      },
    },
    MUIRichTextEditor: {
      root: { width: "100%" },
      placeHolder: { color: "#b71c1c" },
      editorContainer: { marginTop: 10, paddingBottom: 0 },
      hidePlaceholder: { paddingBottom: 0 },
      editor: {
        minHeight: 20,
        marginTop: 10,
        marginRight: 10,
        paddingBottom: 0,
        wordWrap: "break-word",
      },
    },
  },
});

const App = () => {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <ThemeProvider theme={theme}>
        <ScreenContextProvider>
          <AuthContextProvider>
            <AdminContextProvider>
              <ClientContextProvider>
                <HoursContextProvider>
                  <InventoryContextProvider>
                    <MaintenanceContextProvider>
                      <DataPulseProvider>
                        <NotificationProvider>
                          <ErrorBoundary>
                            <Routes />
                          </ErrorBoundary>
                        </NotificationProvider>
                      </DataPulseProvider>
                    </MaintenanceContextProvider>
                  </InventoryContextProvider>
                </HoursContextProvider>
              </ClientContextProvider>
            </AdminContextProvider>
          </AuthContextProvider>
        </ScreenContextProvider>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
};

export default App;
